<template>
  <div class="dynamic-gallery-item">
    <img :src="src" :alt="sku" @load="onLoadEnd" @error="onLoadEnd" />
  </div>
</template>

<script>
import { PREVIEW_HOST } from '~/config'
import toQueryString from '~/utils/toQueryString'
import galleryItemLoad from '~/mixins/gallery-item-load'
import customValuesImageParser from '~/utils/customValuesImageParser'

export default {
  name: 'DynamicGalleryItem',
  mixins: [galleryItemLoad],
  props: {
    /** Product SKU */
    sku: {
      type: String,
      required: true,
    },
    /** Material slug */
    material: {
      type: String,
      required: true,
    },
    /** Key-value customization */
    customValues: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    src() {
      const dirName =
        process.env.NODE_ENV !== 'production' ? 'dev' : 'custom-pictures'
      const customValues = customValuesImageParser(this.customValues, dirName)

      const urlParams = toQueryString(customValues, {
        removeBlankKeys: true,
      }).toString()

      return `${PREVIEW_HOST}/${this.sku}/${this.material}/mockup?${urlParams}`
    },
  },
}
</script>

<style lang="scss" scoped>
.image__loading-backdrop {
  opacity: 0.9;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: #eee;
}
</style>
